import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var updateUserRes;
export const updateUserTodo = createAsyncThunk('updateUser', async (data) => {
    try {
        const formData = new FormData();
        formData.append('name', data.user_name);
        formData.append('email', data.email);
        formData.append('phone', data.phone_no);
        formData.append('designation_id', data.designation);
        formData.append('userRole', data.role || 'staff');
        formData.append('department_id', data.department);
        formData.append('status', data.status || 'Active');
        formData.append('path', data.path || 'category');
        if (data.profile_image) {
            formData.append('profile_image', data.profile_image || '');
        }

        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL + `user/${data?.id}`,
            data: formData,
            headers: { "Content-Type": "multipart/form-data", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return updateUserRes = res

    } catch (error) {
        return updateUserRes = error.response
    }
})




